import firebase from "firebase/app";
import 'firebase/database';
import "firebase/performance";

const firebaseConfig = {
    apiKey: "AIzaSyBc_CDLzcEEdC5aNvRXyzFN_oSwrTJE-5o",
    authDomain: "greencobra.firebaseapp.com",
    databaseURL: "https://greencobra.firebaseio.com",
    projectId: "greencobra",
    storageBucket: "greencobra.appspot.com",
    messagingSenderId: "935177278484",
    appId: "1:935177278484:web:2adc441f367b2aea"
}

firebase.initializeApp(firebaseConfig);

export const perf = firebase.performance();
export const databaseRef = firebase.database();